import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "reactstrap";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

export const ConfirmQuestion = () => {
  return (
    <Modal.Body className="modal-body-generic">
      {/* <Row className="text-center justify-content-center text-info">
        <FontAwesomeIcon size="2x" icon={faInfoCircle} />
      </Row> */}
      <Row className="text-center justify-content-center text-black mt-2 row-response text-modal-confirm">
        <h4>
          ¿Desea confirmar el envío del formulario?
          {/* <Translate contentKey="global.dialogs.confirm.question">Are you sure you want to save changes?</Translate> */}
        </h4>
      </Row>
    </Modal.Body>
  );
};
